export const NO_VARIODOC_BANNER_COOKIE = "noVariodocBannerHidden";
